import { Text, HStack, Divider, Flex } from '@chakra-ui/react';
import React from 'react';
import CommaFormattedNumber from './CommaFormattedNumber';
import { IoBookmark, IoEyeOutline } from './Icons';

export type ViewLikeCountProps = {
  view: {
    total: number; // sessionCountの合計
    average: number; // totalをarticlesの件数で割って整数にしたもの
  };
  like: {
    total: number; // likeの合計
    average: number; // totalをarticlesの件数で割って整数にしたもの
  };
};

// articlesに対して閲覧数と保存数の合計と平均を計算する
export function calcArticlesViewLineCounts(
  // sessionCount,likeCountのプロパティのみ必要
  articles: { sessionCount: number; likeCount: number }[],
): ViewLikeCountProps {
  const counts: ViewLikeCountProps = {
    view: {
      total: 0,
      average: 0,
    },
    like: {
      total: 0,
      average: 0,
    },
  };

  const articlesCount = articles.length;
  if (!articlesCount) {
    return counts;
  }

  articles.forEach((article) => {
    counts.view.total += article.sessionCount ?? 0;
    counts.like.total += article.likeCount ?? 0;
  });
  counts.view.average = Math.floor(counts.view.total / articlesCount);
  counts.like.average = Math.floor(counts.like.total / articlesCount);

  return counts;
}

const CountItem = ({
  icon,
  totalLabel,
  total,
  averageLabel,
  average,
}: {
  icon: React.ReactNode;
  totalLabel: string;
  total: number;
  averageLabel: string;
  average: number;
}) => (
  <>
    <HStack fontSize="sm" gap={1}>
      {icon}
      <Text>{totalLabel}</Text>
      <Text fontWeight="bold">
        <CommaFormattedNumber>{total}</CommaFormattedNumber>
      </Text>
    </HStack>
    <HStack fontSize="xs" gap={1}>
      <Text>{averageLabel}</Text>
      <Text>
        <CommaFormattedNumber>{average}</CommaFormattedNumber>
      </Text>
    </HStack>
  </>
);

export default function ViewLikeCount({ view, like }: ViewLikeCountProps) {
  return (
    <Flex
      alignItems="center"
      bg="white"
      flexDir="column"
      gap={1}
      py={2.5}
      px={3}
      rounded={4}
      minW={164}
      w="fit-content"
    >
      <CountItem
        icon={<IoEyeOutline color="#999999" />}
        totalLabel="総PV数"
        averageLabel="平均PV数"
        {...view}
      />
      <Divider borderColor="gray.300" my={1} />
      <CountItem
        icon={<IoBookmark color="#999999" />}
        totalLabel="総保存数"
        averageLabel="平均保存数"
        {...like}
      />
    </Flex>
  );
}
